package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.navigation.NavParams
import org.moxultimate.topwithmox.wallpaper.data.WallpaperResponse
import org.moxultimate.topwithmox.wallpapercrud.update.WallpaperUpdatePage

@InitRoute
fun initWallpaperUpdateRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Edit Wallpaper"))

    val urlParams: dynamic = js("new URLSearchParams(window.location.search)")
    fun param(key: String): String = (urlParams.get(key) as? String).orEmpty()

    val wallpaperResponse = WallpaperResponse(
        id            = param(NavParams.ID).toLongOrNull() ?: 0L,
        name          = param(NavParams.TITLE),
        description   = param(NavParams.DESCRIPTION),
        series        = param(NavParams.SERIES),
        type          = param(NavParams.TYPE),
        imagePath     = param(NavParams.IMAGE_PATH),
        thumbnailPath = param(NavParams.THUMBNAIL_PATH),
        panoramaPath  = param(NavParams.PANORAMA_PATH).ifBlank { null },
        videoLink     = param(NavParams.VIDEO_LINK),
        createdAt     = param(NavParams.CREATED_AT),
        tags          = param(NavParams.TAGS),
        resolution    = param(NavParams.RESOLUTION),
    )
    ctx.data.add(wallpaperResponse)
}

@Page(routeOverride = "wallpaperupdate")
@Layout(".components.layouts.PageLayout")
@Composable
fun WallpaperUpdateRoute() {
    val ctx = rememberPageContext()
    val wallpaperResponse = ctx.data.getValue<WallpaperResponse>()
    WallpaperUpdatePage(wallpaper = wallpaperResponse)
}
